import { SummaryStateType } from 'src/core/models'

const summaryState: SummaryStateType = {
  balance: {
    loading: false,
    list: [],
    error: ''
  },
  filter: 365,
  salesData: {
    loading: false,
    list: [],
    error: '',
    plotData: false
  },
  ordersData: {
    loading: false,
    list: [],
    error: '',
    plotData: false
  },
  deposit: {
    loading: false,
    response: {
      id: ''
    },
    error: '',
    success: false,
    payPalUrl: '',
    creditCardInfo: {
      Ds_SignatureVersion: '',
      Ds_MerchantParameters: '',
      Ds_Signature: ''
    },
    submit: false
  },
  withdraw: {
    loading: false,
    success: false,
    error: ''
  }
}
export { summaryState as initialState }
